
export const injectAgentScript =
  (doc: Document) =>
  (dep: {
    agentSrc: string;
    agentScriptId: string;
    // expect script type as a parameter since JSDOM(testing lib) can't handle script tag module type
    scriptType?: "module";
  }): Promise<void> => {
    const script = doc.createElement("script");
    if (dep.scriptType) {
      script.type = dep.scriptType;
    }
    script.id = dep.agentScriptId;
    script.src = dep.agentSrc;
    let windowErrorEventListener: (ev: ErrorEvent) => void
    const result = new Promise<void>((resolve, reject) => {
      windowErrorEventListener = (ev) => {
        if (doc.currentScript === script) {
          reject(ev)
        }
      }
      doc.defaultView?.addEventListener('error', windowErrorEventListener)
      script.addEventListener('load', () => resolve());
      script.addEventListener("error", reject);
    }).finally(() => doc.defaultView?.removeEventListener('error', windowErrorEventListener));
    doc.head.appendChild(script);
    return result;
  };

export const checkAgentScriptExist =
  (doc: Document) =>
  (dep: { agentScriptId: string }): boolean => {
    const script = doc.getElementById(dep.agentScriptId);
    return script?.id === dep.agentScriptId;
  };

export const loadScript =
  (doc: Document) =>
  async (dep: {
    agentSrc: string;
    agentScriptId: string;
    scriptType?: "module";
  }): Promise<void> => {
    const agentScriptExist = checkAgentScriptExist(doc)(dep);
    if (agentScriptExist) {
      throw new Error(
        "Livecycle agent script already injected, this may be due to multiple initialization"
      );
    }
    return await injectAgentScript(doc)(dep);
  };
